module.exports = __webpack_public_path__ + "img/opensea-logo.3a545aa1.png";